import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    auths: [],
    auth: {
        id: 0,
        name: "",
        lastName: "",
        email: "",
        password: "",
        repassword: "",
    },
    token: "",
    authValidation: {
        isValid: true,
        isAuthInfoValid: false,
        isAuthGeneralInfoValid: false,
        name: {
            isValid: true,
            errorMessage: "El campo name no debe estar vacio",
        },
        lastName: {
            isValid: true,
            errorMessage: "El campo lastName no debe estar vacio",
        },
        email: {
            isValid: true,
            errorMessage: "El campo email no debe estar vacio",
        },
        password: {
            isValid: true,
            errorMessage: "Contraseña incorrecta",
        },
        repassword: {
            isValid: true,
            errorMessage: "Contraseña incorrecta",
        }
    },
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        restartState(state) {
            state.auth = {};
            state.auths = [];
        },
        setauths(state, actions) {
            state.auths = actions.payload.auths;
            state.auth =
                actions.payload.auth !== undefined ? actions.payload.auth : {};
        },
        setauth(state, actions) {
            state.auth = actions.payload.auth;
            state.auths =
                actions.payload.auths !== undefined ? actions.payload.auths : [];
        },
        settoken(state, actions) {
            state.token = actions.payload.token;
        },
        modifyPropertyValue(state, actions) {
            state.auth[actions.payload.id] = actions.payload.value;
        },
        setIsValid(state, actions) {
            state.authValidation = {
                name: {
                    ...state.authValidation.name,
                    isValid: actions.payload.name !== "",
                },
                lastName: {
                    ...state.authValidation.lastName,
                    isValid: actions.payload.lastName !== "",
                },
                email: {
                    ...state.authValidation.email,
                    isValid:
                        actions.payload.email !== "" && actions.payload.email.includes("@"),
                },
                password: {
                    ...state.authValidation.password,
                    isValid:
                        actions.payload.password !== "" ||
                        actions.payload.password !== actions.payload.repassword,
                }
            };
            state.authValidation.isValid =
                state.authValidation.name.isValid &&
                state.authValidation.lastName.isValid &&
                state.authValidation.email.isValid;

            state.authValidation.isAuthInfoValid =
                state.authValidation.email.isValid &&
                state.authValidation.password.isValid;
        },
        setAuthGeneralInfoValid(state, actions) {
            state.authValidation = {
                name: {
                    ...state.authValidation.name,
                    isValid: actions.payload.name !== "",
                },
                lastName: {
                    ...state.authValidation.lastName,
                    isValid: actions.payload.lastName !== "",
                },
                email: {
                    ...state.authValidation.email,
                    isValid: true,
                },
                password: {
                    ...state.authValidation.password,
                    isValid: true,
                },
            };

            state.authValidation.isAuthGeneralInfoValid =
                state.authValidation.name.isValid &&
                state.authValidation.lastName.isValid &&
                state.authValidation.email.isValid
            state.authValidation.password.isValid;
        },
        setAuthInfoValid(state, actions) {
            state.authValidation = {
                name: {
                    ...state.authValidation.name,
                    isValid: true,
                },
                lastName: {
                    ...state.authValidation.lastName,
                    isValid: true,
                },
                email: {
                    ...state.authValidation.email,
                    isValid: true,
                },
                password: {
                    ...state.authValidation.password,
                    isValid:
                        actions.payload.password !== "" ||
                        actions.payload.password !== actions.payload.repassword,
                }
            };

            state.authValidation.isAuthInfoValid =
                state.authValidation.email.isValid &&
                state.authValidation.password.isValid;
        },

        setFieldValid(state, actions) {
            state.authValidation[actions.payload.id].isValid = actions.payload.value;
        },
    },
});

export const authActions = authSlice.actions;
export default authSlice;
